import Button from "@mui/material/Button";
import TableRow from "@mui/material/TableRow";
import EditIcon from "@mui/icons-material/Edit";
import TableCell from "@mui/material/TableCell";
import DeleteIcon from "@mui/icons-material/Delete";
import ButtonGroup from "@mui/material/ButtonGroup";

import { columns } from "./common";

export default function WarehouseTableRow({ row, buttonsActive, actions }) {
	const handleEditRowClick = () => {
		actions.editRow(row.id);
	};
	const handleDeleteRowClick = () => {
		actions.tryDeleteRow(row.id);
	};
	return (
		<>
			<TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
				{columns.map((column) => (
					<TableCell key={column.id} align={column.align}>
						{column.id === "name" && row.name}
						{column.id === "city" && row.city}
						{column.id === "alias1C" && row.alias1C}
						{column.id === "buttons" && (
							<div style={{ display: "flex", gap: 15 }}>
								<ButtonGroup
									disabled={!buttonsActive}
									variant="outlined"
									aria-label="outlined button group"
								>
									<Button onClick={() => handleEditRowClick()}>
										<EditIcon />
									</Button>
									<Button onClick={() => handleDeleteRowClick()} color="error">
										<DeleteIcon />
									</Button>
								</ButtonGroup>
							</div>
						)}
					</TableCell>
				))}
			</TableRow>
		</>
	);
}
